import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAppStore } from "@/store/useAppStore";

function AuthChecking() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-3 bg-slate-50 text-slate-600"
      data-testid="auth-checking"
    >
      <Loader2 className="animate-spin text-indigo-600" size={28} aria-hidden />
      <span className="text-[13px]">Checking your session…</span>
    </div>
  );
}

/** Route guard — redirects unauthenticated users to /login. */
export function RequireAuth() {
  const { isAuthed, authReady } = useAppStore();
  const location = useLocation();

  if (!authReady) return <AuthChecking />;

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
